import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@socrates/socrates-shared';

@Component({
	// tslint:disable-next-line
	selector: '[logout]',
	template: '',
	standalone: false,
})
export class LogoutComponent implements OnInit {
	constructor(
		private userService: UserService,
		private router: Router
	) {
	}

	ngOnInit(): void {
		this.userService.logout();
		this.router.navigateByUrl('/login');
	}
}

